module.exports = __webpack_public_path__ + "static/media/cancelar.cb011933.svg";